import {init} from "./init";

export const actions = {
    RESET() {
        Object.keys(init).forEach(key => {
            this[key] = init[key];
        });
        Object.keys(this.$state).forEach(key => {
            if (! Object.hasOwnProperty.call(init, key)) {
                delete this.$state[key];
            }
        });
    },
    RESET_PROPERTY(property) {
        if (Object.hasOwnProperty.call(init, property)) {
            if (Array.isArray(init[property])) {
                this[property] = [];
            } else {
                this[property] = init[property];
            }
        }
    },
    SET_CHARACTER(character) {
        this.character = character;
    },
    SET_LOADOUT(loadout) {
        this.loadout = loadout;
    },
    SET_TREE(tree) {
        this.tree = tree;
    },
    SET_DIVISION(division) {
        this.division = division;
    },
    SET_DIFFICULTY(difficulty) {
        this.difficulty = difficulty;
    },
    SET_MODE(mode) {
        this.mode = mode;
    },
    SET_SOURCE(source) {
        this.source = source;
    },
    SET_SESSION(session) {
        this.session = session;
    },
    INCREMENT_BOUT() {
        this.bout++;
    },
    INCREMENT_LOSSES() {
        this.losses++;
    },
    SET_LOG(log) {
        this.log = log;
    },
    ADD_LOG_ENTRY(entry) {
        this.log.push(Object.assign({}, entry, {time: new Date().getTime()}));
    },
    SET_REWARDS(rewards) {
        this.rewards = rewards;
    },
    SET_MILESTONE(milestone) {
        this.milestone = milestone;
    },
    SET_MULTIPLAYER(multiplayer) {
        this.multiplayer = multiplayer;
    },
    SET_WINNER(winner) {
        this.winner = winner;
    },
    SET_OUTCOME(outcome) {
        this.outcome = outcome;
    },
    SET_MMR_CHANGE(amount) {
        this.mmr_change = amount;
    },
    SET_AD_BUFF(buff) {
        this.adBuff = buff;
    },
    CLEAR_AD_BUFF() {
        this.adBuff = null;
    },
    SET_AD_READY(ready) {
        this.adReady = ready;
    },
    SET_AD_LOADING(loading) {
        this.adLoading = loading;
    },
    SET_PENDING_AD_ULID(ulid) {
        this.pendingAdUlid = ulid;
    },
};
